import React, { forwardRef } from 'react'
import "./print.css"
import myImg from "./estn.png"
import dayjs from 'dayjs';
const DiabeticFormPdf = forwardRef(function Formtest(props, ref) {
    const { formData } = props;
    const fullDateToShortDate = (date) => {
        if (date) {
            const newDate = dayjs(date).format("DD-MM-YYYY");
            return newDate;
        }
        return "";
    }
    return (
        <>
            <div className="wrapper_page" ref={ref}>
                <div className="page_header">
                    <div className="logo">
                        <img src={myImg} alt="logo" />
                    </div>
                    <div className="title">
                        <h2>Diabetic Retinopathy Screening Tool</h2>
                    </div>
                    <div className="facility">
                        <div className="line1"><b>Facility name:</b><span className="spanline">{formData?.facility_name}</span></div>
                        <div className="line1"><b>Facility Type:</b>
                            <label>
                                <input type="checkbox"  value="primary" readOnly checked={formData?.facility_type==="primary"} />
                                <span>Primary</span>
                            </label>
                            <label>
                                <input type="checkbox" value="secondary" readOnly checked={formData?.facility_type==="secondary"} />
                                <span>Secondary</span>
                            </label>
                            <label>
                                <input type="checkbox"  value="tertiary" readOnly checked={formData?.facility_type==="teritary"} />
                                <span>Tertiary</span>
                            </label>
                        </div>
                        <div className="line1"><b>Date:</b><span className="spanline">{formData?.form_filling_Date}</span></div>
                    </div>
                </div>
                <div className="page_body">
                    <div className="page_leftcol">
                        <div className="sect_a">
                            <h6>Section A - Identifying Data</h6>
                            <div className="form">
                                <div className="form_row">
                                    <label>Name</label>&nbsp;&nbsp;
                                    <input type="text" className="input" value={formData?.patient_name} />
                                </div>
                                <div className="form_row">
                                    <label>Age:</label>&nbsp;&nbsp;
                                    <input type="text" className="input small" value={formData?.patient_DOB}/>&nbsp;&nbsp;
                                    <label>Sex:</label>&nbsp;&nbsp;
                                    <input type="text" className="input small" value={formData?.patient_gender} />
                                </div>
                                <div className="form_row">
                                    <label>ID / CMIS Number:</label>&nbsp;&nbsp;
                                    <input type="text" className="input mid" value={formData?.patient_cmis_id}/>
                                </div>
                            </div>
                        </div>
                        <div className="sect_b">
                            <div className="header">
                                <h6>Section B - Presenting Complaint</h6>
                                <label>
                                    <span>None</span>
                                    <input type="checkbox" readOnly checked={formData?.presenting_complaint==="1"} />
                                </label>
                                <label>
                                    <span>Yes</span>
                                    <input type="checkbox" readOnly checked={formData?.presenting_complaint==="2"}/>
                                    <span>(Specify)</span>
                                </label>
                            </div>
                            <table className="table">
                                <tr>
                                    <td rowSpan="2"><b>Redness</b></td>
                                    <td>
                                        <label>
                                            {/* <input type="checkbox" readOnly checked={false}/> */}
                                            <span>L</span>
                                        </label>
                                    </td>
                                    <td>
                                        <label>
                                            <input type="checkbox" value="1" readOnly checked={formData?.presenting_complaint_left_redness?.includes("1")}/>
                                            <span>With pain</span>
                                        </label>
                                        <label>
                                            <input type="checkbox" value="2" readOnly checked={formData?.presenting_complaint_left_redness?.includes("2")}/>
                                            <span>Discharge</span>
                                        </label>
                                        <label>
                                            <input type="checkbox" value="3" readOnly checked={formData?.presenting_complaint_left_redness?.includes("3")}/>
                                            <span>Itchy</span>
                                        </label>
                                        <label>
                                            <input type="checkbox" value="4" readOnly checked={formData?.presenting_complaint_left_redness?.includes("4")}/>
                                            <span>Dry</span>
                                        </label>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label>
                                            {/* <input type="checkbox" readOnly checked={false}/> */}
                                            <span>R</span>
                                        </label>
                                    </td>
                                    <td>
                                        <label>
                                            <input type="checkbox" value="1" readOnly checked={formData?.presenting_complaint_right_redness?.includes("1")}/>
                                            <span>With pain</span>
                                        </label>
                                        <label>
                                            <input type="checkbox" value="2" readOnly checked={formData?.presenting_complaint_right_redness?.includes("2")}/>
                                            <span>Discharge</span>
                                        </label>
                                        <label>
                                            <input type="checkbox" value="3" readOnly checked={formData?.presenting_complaint_right_redness?.includes("3")}/>
                                            <span>Itchy</span>
                                        </label>
                                        <label>
                                            <input type="checkbox" value="4" readOnly checked={formData?.presenting_complaint_right_redness?.includes("4")}/>
                                            <span>Dry</span>
                                        </label>
                                    </td>
                                </tr>
                                <tr>
                                    <td rowSpan="2"><b>Vision Loss</b></td>
                                    <td>
                                        <label>
                                            {/* <input type="checkbox" readOnly checked={false}/> */}
                                            <span>L</span>
                                        </label>
                                    </td>
                                    <td>
                                        <label>
                                            <input type="checkbox" value="1"  readOnly checked={formData?.presenting_complaint_left_visionLoss?.includes("1")}/>
                                            <span>Poor distant vision</span>
                                        </label>
                                        <label>
                                            <input type="checkbox" value="2"  readOnly checked={formData?.presenting_complaint_left_visionLoss?.includes("2")}/>
                                            <span>Poor near vision</span>
                                        </label>
                                        <label>
                                            <input type="checkbox" value="3"  readOnly checked={formData?.presenting_complaint_left_visionLoss?.includes("3")}/>
                                            <span>Gradual</span>
                                        </label>
                                        <label>
                                            <input type="checkbox" value="4"  readOnly checked={formData?.presenting_complaint_left_visionLoss?.includes("4")}/>
                                            <span>Sudden</span>
                                        </label>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label>
                                            {/* <input type="checkbox" readOnly checked={false}/> */}
                                            <span>R</span>
                                        </label>
                                    </td>
                                    <td>
                                        <label>
                                            <input type="checkbox" value="1"  readOnly checked={formData?.presenting_complaint_right_visionLoss?.includes("1")}/>
                                            <span>Poor distant vision</span>
                                        </label>
                                        <label>
                                            <input type="checkbox" value="2"  readOnly checked={formData?.presenting_complaint_right_visionLoss?.includes("2")}/>
                                            <span>Poor near vision</span>
                                        </label>
                                        <label>
                                            <input type="checkbox" value="3"  readOnly checked={formData?.presenting_complaint_right_visionLoss?.includes("3")}/>
                                            <span>Gradual</span>
                                        </label>
                                        <label>
                                            <input type="checkbox" value="4"  readOnly checked={formData?.presenting_complaint_right_visionLoss?.includes("4")}/>
                                            <span>Sudden</span>
                                        </label>
                                    </td>
                                </tr>
                                <tr>
                                    <td rowSpan="2"><b>Pain</b></td>
                                    <td>
                                        <label>
                                            {/* <input type="checkbox" readOnly checked={false}/> */}
                                            <span>L</span>
                                        </label>
                                    </td>
                                    <td>
                                        <label>
                                            <input type="checkbox" value="1"  readOnly checked={formData?.presenting_complaint_left_pain?.includes("1")}/>
                                            <span>Severe</span>
                                        </label>
                                        <label>
                                            <input type="checkbox" value="2"  readOnly checked={formData?.presenting_complaint_left_pain?.includes("2")}/>
                                            <span>Moderate</span>
                                        </label>
                                        <label>
                                            <input type="checkbox" value="3"  readOnly checked={formData?.presenting_complaint_left_pain?.includes("3")}/>
                                            <span>Mild</span>
                                        </label>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label>
                                            {/* <input type="checkbox" readOnly checked={false}/> */}
                                            <span>R</span>
                                        </label>
                                    </td>
                                    <td>
                                        <label>
                                            <input type="checkbox" value="1"  readOnly checked={formData?.presenting_complaint_right_pain?.includes("1")}/>
                                            <span>Severe</span>
                                        </label>
                                        <label>
                                            <input type="checkbox" value="2"  readOnly checked={formData?.presenting_complaint_right_pain?.includes("2")}/>
                                            <span>Moderate</span>
                                        </label>
                                        <label>
                                            <input type="checkbox" value="3"  readOnly checked={formData?.presenting_complaint_right_pain?.includes("3")}/>
                                            <span>Mild</span>
                                        </label>
                                    </td>
                                </tr>
                                <tr>
                                    <td rowSpan="2"><b>Eye Injury</b></td>
                                    <td>
                                        <label>
                                            {/* <input type="checkbox" readOnly checked={false}/> */}
                                            <span>L</span>
                                        </label>
                                    </td>
                                    <td>
                                        <label>
                                            <input type="checkbox" value="1"  readOnly checked={formData?.presenting_complaint_left_eyeInjury?.includes("1")}/>
                                            <span>Chemical</span>
                                        </label>
                                        <label>
                                            <input type="checkbox" value="2"  readOnly checked={formData?.presenting_complaint_left_eyeInjury?.includes("2")}/>
                                            <span>Hot liquid/fire</span>
                                        </label>
                                        <label>
                                            <input type="checkbox" value="3"  readOnly checked={formData?.presenting_complaint_left_eyeInjury?.includes("3")}/>
                                            <span>Foreign Body</span>
                                        </label>
                                        <label>
                                            <input type="checkbox" value="4"  readOnly checked={formData?.presenting_complaint_left_eyeInjury?.includes("4")}/>
                                            <span>Blunt force trauma</span>
                                        </label>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label>
                                            {/* <input type="checkbox" readOnly checked={false}/> */}
                                            <span>R</span>
                                        </label>
                                    </td>
                                    <td>
                                        <label>
                                            <input type="checkbox" value="1"  readOnly checked={formData?.presenting_complaint_right_eyeInjury?.includes("1")}/>
                                            <span>Chemical</span>
                                        </label>
                                        <label>
                                            <input type="checkbox" value="2"  readOnly checked={formData?.presenting_complaint_right_eyeInjury?.includes("2")}/>
                                            <span>Hot liquid/fire</span>
                                        </label>
                                        <label>
                                            <input type="checkbox" value="3"  readOnly checked={formData?.presenting_complaint_right_eyeInjury?.includes("3")}/>
                                            <span>Foreign Body</span>
                                        </label>
                                        <label>
                                            <input type="checkbox" value="4"  readOnly checked={formData?.presenting_complaint_right_eyeInjury?.includes("4")}/>
                                            <span>Blunt force trauma</span>
                                        </label>
                                    </td>
                                </tr>
                                <tr>
                                    <td rowSpan="2"><b>Visual Disturbances</b></td>
                                    <td>
                                        <label>
                                            {/* <input type="checkbox" readOnly checked={false}/> */}
                                            <span>L</span>
                                        </label>
                                    </td>
                                    <td>
                                        <label>
                                            <input type="checkbox" value="1"  readOnly checked={formData?.presenting_complaint_left_visualDisturbances?.includes("1")}/>
                                            <span>Blurry vision</span>
                                        </label>
                                        <label>
                                            <input type="checkbox" value="2"  readOnly checked={formData?.presenting_complaint_left_visualDisturbances?.includes("2")}/>
                                            <span>Tunnel vision</span>
                                        </label>
                                        <label>
                                            <input type="checkbox" value="3"  readOnly checked={formData?.presenting_complaint_left_visualDisturbances?.includes("3")}/>
                                            <span>Spots</span>
                                        </label>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label>
                                            {/* <input type="checkbox" readOnly checked={false}/> */}
                                            <span>R</span>
                                        </label>
                                    </td>
                                    <td>
                                        <label>
                                            <input type="checkbox" value="1"  readOnly checked={formData?.presenting_complaint_right_visualDisturbances?.includes('1')}/>
                                            <span>Blurry vision</span>
                                        </label>
                                        <label>
                                            <input type="checkbox" value="2"  readOnly checked={formData?.presenting_complaint_right_visualDisturbances?.includes("2")}/>
                                            <span>Tunnel vision</span>
                                        </label>
                                        <label>
                                            <input type="checkbox" value="3"  readOnly checked={formData?.presenting_complaint_right_visualDisturbances?.includes("3")}/>
                                            <span>Spots</span>
                                        </label>
                                    </td>
                                </tr>
                            </table>
                            <div className="random_form">
                                <p><span className="prop">Other Complaints</span><span className="val">{formData?.presenting_complaint_otherComplaints}</span></p>
                            </div>
                            <table className="noborder">
                                <tr>
                                    <td>Review of systems:</td>
                                    <td>
                                        <label>
                                            <input type="checkbox"  value="1"  readOnly checked={formData?.presenting_complaint_reviewSystem?.includes("1")} />
                                            <span>Pain</span>
                                        </label>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label>
                                            <input type="checkbox" value="2" readOnly checked={formData?.presenting_complaint_reviewSystem?.includes("2")} />
                                            <span>Weight changes</span>
                                        </label>
                                    </td>
                                    <td>
                                        <label>
                                            <input type="checkbox"  value="3"readOnly checked={formData?.presenting_complaint_reviewSystem?.includes("3")} />
                                            <span>Fatigue/Tiredness</span>
                                        </label>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label>
                                            <input type="checkbox"  value="4"readOnly checked={formData?.presenting_complaint_reviewSystem?.includes("4")} />
                                            <span>Recurrent skin infections</span>
                                        </label>
                                    </td>
                                    <td>
                                        <label>
                                            <input type="checkbox" value="5" readOnly checked={formData?.presenting_complaint_reviewSystem?.includes("5")} />
                                            <span>Slow healing Wound/Ulcer</span>
                                        </label>
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan="2">
                                        <label>
                                            <input type="checkbox" value="6" readOnly checked={formData?.presenting_complaint_reviewSystem?.includes("6")} />
                                            <span>Numbness or tingling of hands/feet</span>
                                        </label>
                                    </td>
                                </tr>
                            </table>
                        </div>
                        <div className="sect_c">
                            <h6>Section C - Focused history</h6>
                            <p className="line1">
                                Past Ocular History
                                <label>
                                    <input type="checkbox" value="1" readOnly checked={formData?.focused_past_ocular_history==="1"}/>
                                    <span>Yes</span>
                                </label>
                                <label>
                                    <input type="checkbox" value="2" readOnly checked={formData?.focused_past_ocular_history==="2"}/>
                                    <span>No</span>
                                </label>
                            </p>
                            <p className="line2">
                                If yes, Specify<br />
                                <span>{formData?.focused_past_ocular_history_comment}</span>
                            </p>
                            <table>
                                <tr>
                                    <td colSpan="3">Past Medical History and Comorbidity</td>
                                </tr>
                                <tr>
                                    <td>
                                        <label>
                                            <input type="checkbox" readOnly value="1"  checked={formData?.pasthistory_comborbidity?.includes("1")}/>
                                            <span>Diabetes</span>
                                        </label>
                                    </td>
                                    <td>
                                        <label>
                                            <input type="checkbox" readOnly value="2"  checked={formData?.pasthistory_comborbidity?.includes("2")}/>
                                            <span>Hypertension</span>
                                        </label>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label>
                                            <input type="checkbox" readOnly value="3"  checked={formData?.pasthistory_comborbidity?.includes("3")}/>
                                            <span>Family History of Diabetes</span>
                                        </label>
                                    </td>
                                    <td>
                                        <label>
                                            <input type="checkbox" readOnly value="4"  checked={formData?.pasthistory_comborbidity?.includes("4")}/>
                                            <span>Stroke/CVA/TIA</span>
                                        </label>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label>
                                            <input type="checkbox" readOnly value="5"  checked={formData?.pasthistory_comborbidity?.includes("5")}/>
                                            <span>Cardiovascular Disease</span>
                                        </label>
                                    </td>
                                    <td>
                                        <label>
                                            <input type="checkbox" readOnly value="6"  checked={formData?.pasthistory_comborbidity?.includes("6")}/>
                                            <span>Dyslipidemia</span>
                                        </label>
                                    </td>
                                    <td>
                                        <label>
                                            <input type="checkbox" readOnly value="7"  checked={formData?.pasthistory_comborbidity?.includes("7")}/>
                                            <span>TB</span>
                                        </label>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label>
                                            <input type="checkbox" readOnly value="8"  checked={formData?.pasthistory_comborbidity?.includes("8")}/>
                                            <span>Chronic Kidney disease</span>
                                        </label>
                                    </td>
                                    <td>
                                        <label>
                                            <input type="checkbox" readOnly value="9"  checked={formData?.pasthistory_comborbidity?.includes("9")}/>
                                            <span>Obesity</span>
                                        </label>
                                    </td>
                                    <td>
                                        <label>
                                            <input type="checkbox" readOnly value="10"  checked={formData?.pasthistory_comborbidity?.includes("10")}/>
                                            <span>HIV</span>
                                        </label>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        Are you on treatment?
                                        <label>&nbsp;&nbsp;
                                            <input type="checkbox" readOnly value="1" checked={formData?.on_treatment==="1"}/>
                                            <span>Yes</span>
                                        </label>
                                        <label>&nbsp;&nbsp;
                                            <input type="checkbox" readOnly value="2" checked={formData?.on_treatment==="2"}/>
                                            <span>No</span>
                                        </label>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        If yes
                                        <label>
                                        &nbsp;&nbsp;<input type="checkbox" readOnly value="1" checked={formData?.treatment_type?.includes("1")}/>
                                            <span>Traditional</span>
                                        </label>
                                        <label>&nbsp;&nbsp;
                                            <input type="checkbox" readOnly value="2" checked={formData?.treatment_type?.includes("2")}/>
                                            <span>Conventional</span>
                                        </label>
                                    </td>
                                </tr>
                            </table>
                        </div>
                        <div className="sect_d">
                            <h6>Section D – Known patients with DM.</h6>
                            <p className="line1">Treatment duration(years): <span>{formData?.treatment_years}</span> Date of diagnosis <span>{formData?.date_of_diagnosis}</span></p>
                            <div className="line2">
                                <label>
                                    <input type="checkbox" readOnly value="1" checked={formData?.type_of_diagnosis==="1"}/>
                                    <span>Type I</span>
                                </label>
                                <label>
                                    <input type="checkbox" readOnly value="2" checked={formData?.type_of_diagnosis==="2"}/>
                                    <span>Type II</span>
                                </label>
                            </div>
                            <p>
                                Currently on Medication?
                                <label className="me2">
                                    <input type="checkbox" value="yes" readOnly checked={formData?.current_medication==="yes"}/>
                                    <span>Yes</span>
                                </label>
                                <label>
                                    <input type="checkbox" value="no" readOnly checked={formData?.current_medication==="no"}/>
                                    <span>No</span>
                                </label>
                            </p>
                            {formData?.current_medication==="yes" && <p>
                                Medication Type
                                <label className="me2">
                                    <input type="checkbox" value="Oral" readOnly checked={formData?.medication_oral_injection?.includes("Oral")}/>
                                    <span>Oral</span>
                                </label>
                                <label>
                                    <input type="checkbox" value="Injectables" readOnly checked={formData?.medication_oral_injection?.includes("Injectables")}/>
                                    <span>Injectables</span>
                                </label>
                            </p>}
                            <p className="line4">
                                Blood sugar level RBS<span className='bloodtest'>{formData?.blood_sugar_level?.RBS}</span>FBS<span className='bloodtest'>{formData?.blood_sugar_level?.FBS}</span>HbA1c<span className='bloodtest'>{formData?.blood_sugar_level?.HbA1c}</span>
                            </p>
                            <p>Blood sugar levels</p>
                            <p>
                                <label className="me2">
                                    <input type="checkbox" value="1" readOnly checked={formData?.blood_sugar_levels === "1"} />
                                    <span>Well controlled</span>
                                </label>
                                <label className="me2">
                                    <input type="checkbox" value="2" readOnly checked={formData?.blood_sugar_levels === "2"} />
                                    <span>Poorly controlled</span>
                                </label>
                                <label className="me2">
                                    <input type="checkbox" value="3" readOnly checked={formData?.blood_sugar_levels === "3"} />
                                    <span>Not Monitored</span>
                                </label>
                            </p>
                            <table>
                                <tr>
                                    <td colSpan="3"><b>Risk Factors</b></td>
                                </tr>
                                <tr>
                                    <td>
                                        <b>Exercise</b>
                                    </td>
                                    <td>
                                        <label>
                                            <input type="checkbox" readOnly value="1" checked={formData?.risk_factor_excercise==="1"}/>
                                            <span>Very active</span>
                                        </label>
                                    </td>
                                    <td>
                                        <label>
                                            <input type="checkbox" readOnly value="2" checked={formData?.risk_factor_excercise==="2"}/>
                                            <span>Moderately active</span>
                                        </label>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                    </td>
                                    <td>
                                        <label>
                                            <input type="checkbox" readOnly value="3" checked={formData?.risk_factor_excercise==="3"}/>
                                            <span>Somewhat active</span>
                                        </label>
                                    </td>
                                    <td>
                                        <label>
                                            <input type="checkbox" readOnly value="4" checked={formData?.risk_factor_excercise==="4"}/>
                                            <span>Not active</span>
                                        </label>
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan="3">
                                        <p><b>Alcohol use</b> (units per week) <span className="spanline">{formData?.alochol_use}</span></p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <b>Diet</b>
                                    </td>
                                    <td>
                                        <label>
                                            <input type="checkbox" value="1" readOnly checked={formData?.diet==="1"}/>
                                            <span>Healthy</span>
                                        </label>
                                    </td>
                                    <td>
                                        <label>
                                            <input type="checkbox" value="2" readOnly checked={formData?.diet==="2"}/>
                                            <span>Unhealthy</span>
                                        </label>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <b>Smoker</b>
                                    </td>
                                    <td>
                    <label>
                      <input type="checkbox" readOnly value="Yes" checked={formData?.smoker==="Yes"}/>
                      <span>Yes</span>
                    </label>
                  </td>
                  <td>
                    <label>
                      <input type="checkbox" readOnly value="No" checked={formData?.smoker==="No"}/>
                      <span>No</span>
                    </label>
                  </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                    <div className="page_rightcol">
                        <div className="sect_e">
                            <h6>Section E: Color Blindness Test</h6>
                            <table className="table" cellPadding="2">
                                <tr>
                                    <td></td>
                                    <td>None</td>
                                    <td>Red/Green</td>
                                    <td>Blue/Yellow</td>
                                    <td>Complete</td>
                                </tr>
                                <tr>
                                    <td>L</td>
                                    <td><input type="checkbox" value="" readOnly checked={formData?.color_blindness_left==="0"}/></td>
                                    <td><input type="checkbox" value="1" readOnly checked={formData?.color_blindness_left==="1"}/></td>
                                    <td><input type="checkbox" value="2" readOnly checked={formData?.color_blindness_left==="2"}/></td>
                                    <td><input type="checkbox" value="3" readOnly checked={formData?.color_blindness_left==="3"}/></td>
                                </tr>
                                <tr>
                                    <td>R</td>
                                    <td><input type="checkbox" value="" readOnly checked={formData?.color_blindness_right==="0"}/></td>
                                    <td><input type="checkbox" value="1" readOnly checked={formData?.color_blindness_right==="1"}/></td>
                                    <td><input type="checkbox" value="2" readOnly checked={formData?.color_blindness_right==="2"}/></td>
                                    <td><input type="checkbox" value="3" readOnly checked={formData?.color_blindness_right==="3"}/></td>
                                </tr>
                            </table>
                        </div>
                        <div className="sect_f">
                            <h6>Section F: Uncorrected Visual Acuity Test</h6>
                            <table className="table" cellPadding="2">
                                <tr>
                                    <td></td>
                                    <td>6/6</td>
                                    <td>6/9</td>
                                    <td>6/12</td>
                                    <td>6/18</td>
                                    <td>6/24</td>
                                    <td>6/36</td>
                                    <td>6/60</td>
                                </tr>
                                <tr>
                                    <td>L</td>
                                    <td><input type="checkbox"  readOnly value="1" checked={formData?.visual_acuity_left==="1"} /></td>
                                    <td><input type="checkbox"  readOnly value="2" checked={formData?.visual_acuity_left==="2"} /></td>
                                    <td><input type="checkbox"  readOnly value="3" checked={formData?.visual_acuity_left==="3"} /></td>
                                    <td><input type="checkbox"  readOnly value="4" checked={formData?.visual_acuity_left==="4"} /></td>
                                    <td><input type="checkbox"  readOnly value="5" checked={formData?.visual_acuity_left==="5"} /></td>
                                    <td><input type="checkbox"  readOnly value="6" checked={formData?.visual_acuity_left==="6"} /></td>
                                    <td><input type="checkbox"  readOnly value="6" checked={formData?.visual_acuity_left==="7"} /></td>
                                </tr>
                                <tr>
                                    <td>R</td>
                                    <td><input type="checkbox"  readOnly value="1" checked={formData?.visual_acuity_right==="1"} /></td>
                                    <td><input type="checkbox"  readOnly value="2" checked={formData?.visual_acuity_right==="2"} /></td>
                                    <td><input type="checkbox"  readOnly value="3" checked={formData?.visual_acuity_right==="3"} /></td>
                                    <td><input type="checkbox"  readOnly value="4" checked={formData?.visual_acuity_right==="4"} /></td>
                                    <td><input type="checkbox"  readOnly value="5" checked={formData?.visual_acuity_right==="5"} /></td>
                                    <td><input type="checkbox"  readOnly value="6" checked={formData?.visual_acuity_right==="6"} /></td>
                                    <td><input type="checkbox"  readOnly value="6" checked={formData?.visual_acuity_right==="7"} /></td>
                                </tr>
                            </table>
                        </div>
                        <div className="sect_g">
                            <h6>Section G: DR Grading</h6>
                            <table className="table" cellPadding="2">
                                <tr>
                                    <td>L</td>
                                    <td>R</td>
                                    <td>Diabetic Retinopathy<br />(DR)</td>
                                    <td>Findings Observable on Dilated Ophthalmoscopy</td>
                                </tr>
                                <tr>
                                    <td><input type="checkbox" value="1" readOnly checked={formData?.dr_retinopathy_left==="0"}/></td>
                                    <td><input type="checkbox" value="1" readOnly checked={formData?.dr_retinopathy_right==="0"}/></td>
                                    <td className="bggreen">No apparent DR</td>
                                    <td className="bggreen">No Abnormalities</td>
                                </tr>
                                <tr>
                                    <td><input type="checkbox"  value="2" readOnly checked={formData?.dr_retinopathy_left==="1"}/></td>
                                    <td><input type="checkbox"  value="2" readOnly checked={formData?.dr_retinopathy_right==="1"}/></td>
                                    <td className="bgyellow">Mild Non-proliferative DR</td>
                                    <td className="bgyellow">Microaneurysms only</td>
                                </tr>
                                <tr>
                                    <td><input type="checkbox" value="3" readOnly checked={formData?.dr_retinopathy_left==="2"}/></td>
                                    <td><input type="checkbox" value="3" readOnly checked={formData?.dr_retinopathy_right==="2"}/></td>
                                    <td className="bgorange">Moderate Non-proliferative DR</td>
                                    <td className="bgorange">Microaneurysms and other signs (dot and blot hemorrhages, hard
                                        exudates, cotton-wool
                                        spots), but less than severe non-proliferative DR</td>
                                </tr>
                                <tr>
                                    <td><input type="checkbox" value="4" readOnly checked={formData?.dr_retinopathy_left==="3"}/></td>
                                    <td><input type="checkbox" value="4" readOnly checked={formData?.dr_retinopathy_right==="3"}/></td>
                                    <td className="bgred">Severe Non-proliferative DR</td>
                                    <td className="bgred">
                                        Moderate Non-proliferative DR plus
                                        any of the following:
                                        <ul>
                                            <li>Intraretinal hemorrhages (≥20 in each quadrant)</li>
                                            <li>Definite venous beading (in 2 quadrants)</li>
                                            <li>Intraretinal microvascular abnormalities (in 1 quadrant)</li>
                                            <li>No signs of proliferative retinopathy</li>
                                        </ul>
                                    </td>
                                </tr>
                                <tr>
                                    <td><input type="checkbox" value="5" readOnly checked={formData?.dr_retinopathy_left==="4"}/></td>
                                    <td><input type="checkbox" value="5" readOnly checked={formData?.dr_retinopathy_right==="4"}/></td>
                                    <td className="bgdarkred">Proliferative DR</td>
                                    <td className="bgdarkred">
                                        Presence of one or more of the following:
                                        <ul>
                                            <li>Neovascularization</li>
                                            <li>Vitreous/preretinal hemorrhage</li>
                                        </ul>
                                    </td>
                                </tr>
                            </table>
                        </div>
                        <div className="sect_h">
                            <h6>Section H - Summary Risk Rating for Diabetic Retinopathy</h6>
                            <table className="table" cellPadding="2">
                                <tr>
                                    <td><input type="checkbox" readOnly value="0" checked={formData?.form_risk_rating==="0"}/></td>
                                    <td className="bggreen tdlspc">0 = No current risk</td>
                                </tr>
                                <tr>
                                    <td><input type="checkbox" readOnly value="1" checked={formData?.form_risk_rating==="1"}/></td>
                                    <td className="bgyellow tdlspc">1 = Low risk</td>
                                </tr>
                                <tr>
                                    <td><input type="checkbox" readOnly value="2" checked={formData?.form_risk_rating==="2"}/></td>
                                    <td className="bgorange tdlspc">2 = Moderate risk</td>
                                </tr>
                                <tr>
                                    <td><input type="checkbox" readOnly value="3" checked={formData?.form_risk_rating==="3"}/></td>
                                    <td className="bgred tdlspc">3 = High risk</td>
                                </tr>
                                <tr>
                                    <td><input type="checkbox" readOnly value="4" checked={formData?.form_risk_rating==="4"}/></td>
                                    <td className="bgdarkred tdlspc textwhite">4 = Emergency</td>
                                </tr>
                            </table>
                        </div>
                        <div className="sect_i">
                            <p className="line1"><b>Comments:</b><span className="spanline">{formData?.diabetic_comments}</span></p>
                            <p className="line1"><span className="spanline"></span></p>
                            <p className="line1"><span className="spanline"></span></p>
                            <p className="line1"><span className="spanline"></span></p>
                        </div>
                    </div>
                </div>
                <div className="page_footer">
                    <table width="100%" cellSpacing="10">
                        {/* <tr>
                            <td>
                                <p className="line1"><b>Clinician Name</b><span className="spanline">{formData?.hospital_Name}</span></p>
                            </td>
                            <td>
                                <p className="line1"><b>Clinician Signature</b><span className="spanline"></span></p>
                            </td>
                        </tr> */}
                        <tr>
                            {/* <td>
                                <span className="me2">Referral</span>
                                <label className="me2">
                                    <input type="checkbox" />
                                    <span>Yes</span>
                                </label>
                                <label>
                                    <input type="checkbox" />
                                    <span>No</span>
                                </label>
                            </td> */}
                            <td>
                                <p className="line1"><b>Referral site name</b><span className="spanline">{formData?.hospital_Name}</span></p>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
        </>
    );
});

export default DiabeticFormPdf